import React from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { Api } from "../../api";
import {
  makeStyles,
  Drawer,
  IconButton,
  useTheme,
  Divider,
  AppBar,
  Toolbar,
  Typography,
} from "@material-ui/core";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import MenuIcon from "@material-ui/icons/Menu";
import clsx from "clsx";
import DocumentGroup from "../../types/DocumentGroup";
import PacketDocumentList from "./PacketDocumentList";
import Document from "../../types/Document";
import PacketViewDocument from "./PacketViewDocument";
import queryString from "query-string";

export default function Packet() {
  const { packetId } = useParams();
  const [packet, setPacket] = React.useState<DocumentGroup>();
  const [drawerOpen, setDrawerOpen] = React.useState(true);
  const [selectedDocument, setSelectedDocument] = React.useState<Document>(
    {} as Document
  );
  const history = useHistory();
  const theme = useTheme();
  const classes = useStyles();
  const values = queryString.parse(useLocation().search);

  React.useEffect(() => {
    if (packetId) {
      Api.documentGroups.get(packetId).then((response) => {
        if (!response.data.hasError && response.data.data) {
          let packet = response.data.data;
          if (packet) {
            setPacket(response.data.data);
            if (packet.documents.length > 0) {
              setSelectedDocument(packet.documents[0]);
            }
          }
        }
        console.log(response);
      });
    }
  }, [packetId]);

  return (
    <div className="preview">
      <AppBar
        position="fixed"
        color="secondary"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: drawerOpen,
        })}
      >
        <Toolbar>
          <IconButton
            edge="start"
            className={clsx(classes.menuButton)}
            color="inherit"
            aria-label="menu"
            onClick={() => setDrawerOpen(!drawerOpen)}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" className={classes.title}>
            {packet && packet.groupName}
          </Typography>
        </Toolbar>
      </AppBar>
      <Drawer
        className={classes.drawer}
        variant="persistent"
        anchor="left"
        classes={{
          paper: classes.drawerPaper,
        }}
        open={drawerOpen}
      >
        <div className={classes.sidebar}>
          <div className={classes.drawerHeader}>
            <IconButton
              onClick={() =>
                values.backRoute
                  ? history.push(values.backRoute as string)
                  : history.goBack()
              }
            >
              {theme.direction === "ltr" ? (
                <ChevronLeftIcon className={classes.drawerButton} />
              ) : (
                <ChevronRightIcon />
              )}
            </IconButton>
          </div>
          <Divider />
          {packet && packet.documents ? (
            <div style={{ padding: "30px 30px 30px 30px" }}>
              <PacketDocumentList
                documents={packet.documents}
                selectedDocumentId={selectedDocument.documentId || ""}
                onDocumentClick={(document) => setSelectedDocument(document)}
              />
            </div>
          ) : null}
        </div>
      </Drawer>
      <main
        className={clsx(classes.content, {
          [classes.contentShift]: drawerOpen,
        })}
      >
        <PacketViewDocument documentId={selectedDocument.documentId} />
      </main>
    </div>
  );
}

const drawerWidth = 300;
const useStyles = makeStyles((theme) => ({
  appBar: {
    zIndex: 10000,
    color: "white",
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerButton: {
    color: "#fff",
  },
  offset: {
    ...theme.mixins.toolbar,
  },
  drawer: {
    zIndex: 9999,
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
    border: "none",
  },
  sidebar: {
    background: theme.palette.primary.main,
    color: "#fff",
    minHeight: "100vh",
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    display: "flex",
    flexFlow: "column",
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -drawerWidth,
    minHeight: "calc(100vh)",
    background: "#f5f5f5",
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 300,
  },
  menuButton: {
    marginRight: theme.spacing(2),
    color: "white",
  },
  hide: {
    display: "none",
  },
  title: {
    flexGrow: 1,
    color: "white",
  },
}));
